import React, { Component } from "react";

class Comp2 extends Component {
  constructor() {
    super();
    this.state = {
      name: "ReactJS",
      keyinfo: ''
    };
  }

  componentDidMount() {

    let info = this.props.paraminfo;
    this.setState({ keyinfo: info });
  }
  componentWillReceiveProps(updatedProps) {
    if (updatedProps.paraminfo)
      this.setState({ keyinfo: updatedProps.paraminfo });
  }

  render() {
    return <div id="keyinfo_section">
      <h3>Key Information</h3>
      <div class="aboutinfo keyinfoscrollpad">{this.state.keyinfo}</div>
    </div>
  }
}

export default Comp2;